import { ChangeEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import DialogTitle from '@rossum/components/dialog-title/DialogTitle';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { useReplaceDataset } from '../hooks/useReplaceDataset';
import { UploadArea } from './UploadArea';

const maxFileSize = 52428800; // 50 MB

export const ReplaceDataDialog = ({
  open,
  onClose,
  datasetName,
}: {
  open: boolean;
  onClose: () => void;
  datasetName: string;
}) => {
  const intl = useIntl();
  const [file, setFile] = useState<File | null>(null);
  const { mutate: replaceDataset, isLoading: isReplacing } =
    useReplaceDataset();

  return (
    <Dialog
      open={open}
      component="form"
      onSubmit={e => {
        e.preventDefault();
        if (file) {
          replaceDataset(
            {
              file,
              datasetName,
              encoding: 'utf-8',
              dynamic: true,
            },
            { onSuccess: onClose }
          );
        }
      }}
      onClose={onClose}
    >
      <DialogTitle
        title={intl.formatMessage({ id: 'features.datasets.data.replace' })}
        onClose={onClose}
      />
      <DialogContent>
        <Stack pt={2} spacing={2}>
          <Stack spacing={1}>
            <Typography variant="body1">
              {intl.formatMessage({
                id: 'features.datasets.data.replace.description',
              })}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {intl.formatMessage({
                id: 'features.datasets.data.replace.descriptionWarning',
              })}
            </Typography>
          </Stack>
          <UploadArea
            file={file}
            onUploadChange={(e: ChangeEvent<HTMLInputElement>) => {
              const selectedFile = e.target.files?.[0];
              if (selectedFile) {
                if (selectedFile.size > maxFileSize) {
                  // return setFileSizeError(true);
                }
                // setFileSizeError(false);
                return setFile(selectedFile);
              }
              return setFile(null);
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!file || isReplacing}
        >
          {intl.formatMessage({ id: 'features.datasets.data.replace' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
